const COMPATS_COMPONENT_TYPES = {
  COMPATS_TITLE: 'compats-title',
  CHILDREN: 'children',
  HIGHLIGHTS: 'highlights',
};

export { COMPATS_COMPONENT_TYPES };
